/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Verdict_TitleInputs */

const en_fc_vs_verdict_title = /** @type {(inputs: Fc_Vs_Verdict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The verdict`)
};

/**
* | output |
* | --- |
* | "The verdict" |
*
* @param {Fc_Vs_Verdict_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_verdict_title = /** @type {((inputs?: Fc_Vs_Verdict_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Verdict_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_verdict_title(inputs)
});
export { fc_vs_verdict_title as "fc.vs.verdict.title" }